import '@styles-shared/index.css';
import '@styles/fonts.css';
import '@styles/theme.css';

// Must run first to initialise the browser shim and disable Zod JIT before dependent modules load.
import './init';
import './zod-config';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
